import * as React from "react";
import Content from "../../../Content";
import Axios from "../../Components/Axios";
import moment from "moment";

import {withRouter} from "react-router";
import DataTable from "../../../DataTable";
class KPLogs extends React.Component{

    defaultPath = '/admin/kp_logs/';

    getContentProviders() {
        Axios
            .get('api/kp/list')
            .then(r => this.setState({ contentProviders: r.data }))
            .catch(e => this.props.history.push('/'));
    }

    getLogTypeByCode(type) {
        switch (type) {
            case 'auth': return 'Авторизация';
            case 'add': return 'Создание';
            case 'edit': return 'Редактирование';
            default: return '';
        }
    }

    getLog(params) {

        Axios
            .get('api/kp_logs/list?' + (new URLSearchParams(params)).toString())
            .then(r => {
                let data = r.data.map(v => {
                   v.date = moment(v.dateadd.date).format('YYYY-MM-DD HH:mm:ss');
                   v.logType = this.getLogTypeByCode(v.logType);
                   return v;
                });
                this.setState({ list: data });
                this.state.dataTable.update(data);
            })
            .catch(e => this.props.history.push('/'));

    }

    componentDidMount() {
        this.setState({
            dataTable: DataTable.init({ columns: [
                    'id','logType','title','kpMsisdn','date','employe'
                ] })
        });

        this.getContentProviders();
        this.loadData(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!!this.props.qs && this.props.qs !== prevProps.qs) {
            this.loadData(this);
        }
    }

    loadData(self) {
        let qs = this.props.match.params.params;
        let urlParams = new URLSearchParams(qs ?? '');

        let params = {
            cp: urlParams.get('cp') ?? 0,
            periodFrom: urlParams.get('periodFrom') ?? moment().format("YYYY-MM-DD"),
            periodTo: urlParams.get('periodTo') ?? moment().format("YYYY-MM-DD")
        }

        if(
            params.periodTo !== moment().format("YYYY-MM-DD") ||
            params.periodFrom !== moment().format("YYYY-MM-DD")
        ) {
            this.setState({
                periodType: 'interval',
                periodFrom: params.periodFrom,
                periodTo: params.periodTo
            });
        }

        self.getLog(params);
    }

    constructor(props, context) {
        super(props, context);
        let urlParams = new URLSearchParams(this.props.qs ?? '');
        this.state = {
            contentProviders: [],
            cp: urlParams.get('cp') ?? 0,
            periodFrom: urlParams.get('periodFrom') ?? moment().format("YYYY-MM-DD"),
            periodTo: urlParams.get('periodTo') ?? moment().format("YYYY-MM-DD"),
            periodType: "today",
            list: []
        };
    }

    handleChange(e, element) {
        this.setState({[element]: e.target.value});
    }

    async handleSubmit(e, self) {
        e.preventDefault();
        if(this.state.periodType === "today") {
            await this.setState({
               periodFrom: moment().format("YYYY-MM-DD"),
               periodTo: moment().format("YYYY-MM-DD")
            });
        }

        const searchParams = (
            new URLSearchParams({
                periodFrom: this.state.periodFrom,
                periodTo: this.state.periodTo,
                cp: this.state.cp
            })
        ).toString();

        this.props.history.push(this.defaultPath + searchParams);

    }

    render() {
        return (
            <Content title = "Логи КП">
                <h4 className="mb-3">Логи КП</h4>
                <form className="form-inline" onSubmit={e => this.handleSubmit(e, this)}>
                    <div className="form-group   mb-2 ">
                        <label htmlFor="staticEmail2" className="sr-only">Контент-провайдер</label>
                        <select className="form-control" value = {this.state.cp} onChange={e => this.handleChange(e, 'cp')} >
                            <option value="0">По всем КП</option>
                            {
                                this.state.contentProviders.map(v => <option key={v.id} value={v.id}>{v.title}</option>)
                            }
                        </select>
                    </div>
                    <div className="form-group ml-4  mb-2 ">
                        <label htmlFor="staticEmail2" className="sr-only">Период</label>
                        <select className="form-control" name="period" id="period" value={this.state.periodType} onChange={e => this.handleChange(e, 'periodType')}>
                            <option value="today"> За сегодня</option>
                            <option value="interval"> За период</option>
                        </select>
                    </div>
                    {
                        this.state.periodType === "interval" &&
                        <>
                            <div className="form-group  ml-sm-4  mb-2 periods">
                                <label htmlFor="staticEmail2">Дата с </label>
                                <input className="form-control date ml-2" type="date" value={this.state.periodFrom} onChange={e => this.handleChange(e, 'periodFrom')} />
                            </div>
                            <div className="form-group  ml-sm-4  mb-2 periods">
                                <label htmlFor="staticEmail2">до </label>
                                <input className="form-control date ml-2" type="date" value={this.state.periodTo} onChange={e => this.handleChange(e, 'periodTo')} />
                            </div>
                        </>
                    }
                    <div className="form-group ml-sm-4 mb-2 mt-2">
                        <button type="submit" className="btn btn-primary mb-2">Показать отчет</button>
                    </div>
                </form>
                <div className="table-responsive">
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                        <thead>
                        <tr>
                            <th>LOG_ID</th>
                            <th>Тип лога</th>
                            <th>Название КП</th>
                            <th>Номер телефона КП</th>
                            <th>Дата</th>
                            <th>Пользователь</th>
                        </tr>
                        </thead>
                        <tfoot>
                        <tr>
                            <th>LOG_ID</th>
                            <th>Тип лога</th>
                            <th>Название КП</th>
                            <th>Номер телефона КП</th>
                            <th>Дата</th>
                            <th>Пользователь</th>
                        </tr>
                        </tfoot>
                    </table>

                </div>
            </Content>
        );
    }
}

export default withRouter(KPLogs);